<template>
  <v-dialog @click:outside="closeDialog" :value="dialog" max-width="700px" :persistent="true">
    <v-card>

      <v-card-title class="justify-space-between">
        <h3>업로드</h3>
        <!-- <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn> -->
      </v-card-title>
      <v-card-title class="btn-mobile-align">
        <v-row>
          <v-col>
            <v-row> 
              <h5>파일</h5>
              <span class="ml-3 mt-1" style="color: #888; font-size: 14px; font-weight: 200;">
                현재 업로드 옵션은 <b style="color: #007bff;">{{ uploadStatus }}</b> 입니다.
              </span>

              <v-tooltip bottom color="#eef6ff" style="box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mt-2 ml-1" icon x-small outlined v-bind="attrs" v-on="on">
                    <v-icon class="mdi mdi-information-symbol" />
                  </v-btn>
                </template>
                <div style="color: #006CEA;">
                  <h4>업로드 옵션 설정</h4>
                <v-divider color="#4d9bf5" class="mt-1 mb-1"></v-divider>
                <span style="font-size: 12px;">업로드 옵션은 설정 > 일반설정 > 업로드옵션<br>에서 설정할 수 있습니다.</span>
                </div>
                
              </v-tooltip>

            </v-row>
          </v-col>
        </v-row>

        <div class="btn-mobile">
          <!-- <v-btn elevation="0" outlined class="mr-2 m-btn" :disabled="true">제거</v-btn> -->
          <v-btn elevation="0" dark class="m-btn" @click="handleFileButtonClick">파일 추가</v-btn>
          <input hidden id="file-selector" type="file" accept=".mp4, .mov" multiple @change="handleFileUpload"
            ref="uploader">
        </div>
      </v-card-title>

      <div class="upload_box" @drop.prevent="onDrop($event)" @dragover.prevent="dragover = true"
        @dragenter.prevent="dragover = true" @dragleave.prevent="dragover = false"
        :class="{ 'grey lighten-2': dragover }">
        <v-card-text v-if="!uploadedFiles.length">
          <v-row class="d-flex flex-column" dense align="center" justify="center" style="height: 268px;">
            <v-icon :class="[dragover ? 'mt-2 mb-6' : 'mt-5']" size="60">
              mdi-cloud-upload
            </v-icon>
            <p class="mb-1">파일을 이곳에 드롭하세요</p>
            <span class="upload_txt">업로드는 동시에 <strong>최대 10개</strong> 파일까지 가능합니다.</span>
            <span class="mt-2" style="color: #888; font-size: 12px; font-weight: 200;">파일 하나당 최대 업로드 크기 : 10GB</span>
            <span class="mt-2" style="color: #888; font-size: 12px; font-weight: 200;">
              지원되는 비디오 형식 : <b style="color: #007bff;">MP4, MOV</b>
            </span>
          </v-row>
        </v-card-text>

        <UploadTable :files="uploadedFiles" v-if="uploadedFiles.length" />
      </div>

      <v-row class="pa-5">
        <v-col>

          <!-- <v-btn elevation="0" :disabled="!isUploadButtonEnabled" :dark="uploadedFiles.length > 0"
            @click="startUpload">업로드</v-btn> -->
          <TextButtonBlock buttonText="닫기" :width="'49%'" class="mr-2" @click="closeDialog" />
          <TextButtonBlock buttonText="업로드" :width="'49%'" isPrimary :disabled="!isUploadButtonEnabled"
            :dark="uploadedFiles.length > 0" @click="startUpload" />

        </v-col>
      </v-row>

    </v-card>
  </v-dialog>
</template>


<script>
import UploadTable from '@/components/upload/Upload.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import ToolTip from '@/components/ui/toolltip/ToolTip.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "UploadDialog",
  components: {
    UploadTable,
    TextButtonBlock,
    ToolTip
  },
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dragover: false,
      formattedFileList: [],
      selectedlist: [],
      selected: [],
    };
  },
  computed: {
    ...mapGetters('upload', ['uploadedFiles', 'fileProgress']),
    isUploadButtonEnabled() {
      return this.uploadedFiles.some(file => file.status === 'pending');
    },
    ...mapGetters('user', ['upload']),
    uploadStatus() {
      if (this.upload === 1) {
        return '업로드 + 인코딩';
      } else if (this.upload === 2) {
        return '업로드';
      } else {
        return '업로드';
      }
    },
  },
  methods: {
    ...mapActions('upload', [
      'addUploadedFile',
      'removeUploadedFile',
      'setFileProgress',
      'initFileProgress',
      'addFiles',
      'uploadFiles',
    ]),
    handleFileUpload(event) {
      const files = event.target.files;
      if (files.length > 0) {
        this.addFiles(Array.from(files));
        event.target.value = '';
      }
    },
    startUpload() {
      this.uploadFiles();
    },
    closeDialog() {
      this.$emit("update:dialog", false);
    },
    onDrop(e) {
      this.dragover = false;
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        this.addFiles(Array.from(files));
      }
    },
    handleFileButtonClick() {
      this.$refs.uploader.click();
    },
  }
};
</script>

<style scoped>
.upload_box {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin: 0px 20px 0px 20px;
}
.upload_txt{
  font-size: 12px;
  color: #c4c4c4;
  background: #f8f8f8;
  padding: 2px 8px 2px 8px;
  border-radius: 4px;
}
.upload_txt strong {
  color: #aaa;
}
</style>
